import email from "../assets/email.png";
import mobile from "../assets/whatsapp.png";
import api from "../assets/api.png";
import cpp from "../assets/cpp.png";
import css from "../assets/css.png";
import figma from "../assets/figma.png";
import git from "../assets/git.png";
import graphql from "../assets/graphql.png";
import html from "../assets/html.png";
import javascript from "../assets/javascript.svg";
import node from "../assets/node.png";
import python from "../assets/python.svg";
import react from "../assets/react.svg";
import redux from "../assets/redux.png";
import sass from "../assets/sass.png";
import typescript from "../assets/typescript.png";

import about01 from "../assets/about01.png";
import about02 from "../assets/about02.png";
import about03 from "../assets/about03.png";
import about04 from "../assets/about04.png";

import profile2 from "../assets/profile1.png";
import circle from "../assets/circle.svg";
import logo2 from "../assets/logo2.svg";

const images = {
  email,
  mobile,
  api,
  cpp,
  css,
  figma,
  git,
  graphql,
  html,
  javascript,
  node,
  python,
  react,
  redux,
  sass,
  typescript,
  about01,
  about02,
  about03,
  about04,
  profile2,
  circle,
  logo2,
};

export default images;
